module.exports = __webpack_public_path__ + "img/business-solutions-hero-tablet@2x.baa133ea.webp";